export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
if (!API_BASE_URL) {
  throw new Error('VITE_API_BASE_URL is not set');
}
console.log('API_BASE_URL:', API_BASE_URL);

// Configure axios defaults
import axios from 'axios';
// Guard for test environments or unusual setups where axios.default may be undefined
if (axios && axios.defaults) {
  axios.defaults.withCredentials = true;
}

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/token`,
  REFRESH_TOKEN: `${API_BASE_URL}/token/refresh`,
  REGISTER: `${API_BASE_URL}/users/register`,
  USER_DATA: `${API_BASE_URL}/users/latest`,
  UPDATE_USER: `${API_BASE_URL}/users`,
  SUBSTANCES: `${API_BASE_URL}/substances`,
  CHANGE_PASSWORD: `${API_BASE_URL}/users`,
  FORGOT_PASSWORD: `${API_BASE_URL}/users/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/users/reset-password`,
  JOURNAL: `${API_BASE_URL}/journal`,
  USERS: `${API_BASE_URL}/users`,
  AUTH: `${API_BASE_URL}/token`,
  REFRESH: `${API_BASE_URL}/token/refresh`,
  CHECK_CONCENTRATIONS: `${API_BASE_URL}/check-concentrations`,
  EXPORT: `${API_BASE_URL}/substances/export`,
  IMPORT: `${API_BASE_URL}/substances/import`,
  AI_INSIGHTS: `${API_BASE_URL}/substances/ai-insights`,
  MENTAL_HEALTH_INSIGHTS: `${API_BASE_URL}/journal/mental-health-insights`,
  GET_USER_CONDITIONS: `${API_BASE_URL}/users`,
  ADD_USER_CONDITION: `${API_BASE_URL}/users`,
  REMOVE_USER_CONDITION: `${API_BASE_URL}/users`,
  DRUG_SEARCH: `${API_BASE_URL}/drugs/search`,
  DRUG_SEARCH_SYNONYMS: `${API_BASE_URL}/drugs/search/synonyms`,
  DRUGS: `${API_BASE_URL}/drugs`,
  DRUGS_AI_FILL: `${API_BASE_URL}/drugs/ai-fill`,
  USER_DRUGS: `${API_BASE_URL}/user/drugs`,
  USER_DRUGS_AI_FILL: `${API_BASE_URL}/user/drugs/ai-fill`,
  USER_DRUGS_SUGGESTIONS: `${API_BASE_URL}/user/drugs/suggestions`,
  MY_SUBSTANCES: `${API_BASE_URL}/my-substances`,
  GOALS: `${API_BASE_URL}/goals`,
  GOALS_RECALCULATE: `${API_BASE_URL}/goals/recalculate`,
  GOOGLE_AUTH_URL: `${API_BASE_URL}/auth/google/url`,
  GOOGLE_CALLBACK: `${API_BASE_URL}/auth/google/callback`,
  PAYMENTS_CHECKOUT: `${API_BASE_URL}/payments/checkout`,
  PAYMENTS_CREATE_INTENT: `${API_BASE_URL}/payments/create-payment-intent`,
  PAYMENTS_CONFIRM: `${API_BASE_URL}/payments/confirm-payment`
} as const